/*
 * Entro collection card quantity (Oct 2026)
 * Single-variant products get - qty + and Add to cart right on the card.
 * Uses EntroBulk.addItems, so the 150-line cap and stock limits apply.
 */
(function () {
  if (window.EntroCard) return;
  window.EntroCard = true;

  function clamp(card, input, v) {
    var max = card.getAttribute('data-max');
    v = parseInt(v, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (max !== null && max !== '' && v > Number(max)) v = Math.max(1, Number(max));
    input.value = v;
    return v;
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-entro-card]');
    if (!card) return;
    var input = card.querySelector('input');
    if (e.target.closest('.eb-card__minus')) { e.preventDefault(); clamp(card, input, (parseInt(input.value, 10) || 1) - 1); return; }
    if (e.target.closest('.eb-card__plus')) { e.preventDefault(); clamp(card, input, (parseInt(input.value, 10) || 0) + 1); return; }
    var add = e.target.closest('.eb-card__add');
    if (!add) return;
    e.preventDefault();
    if (!window.EntroBulk) return;
    var qty = clamp(card, input, input.value);
    var msg = card.querySelector('.eb-card__msg');
    var label = add.getAttribute('data-label') || add.textContent;
    add.setAttribute('data-label', label);
    add.disabled = true;
    add.textContent = 'Adding...';
    msg.innerHTML = '';
    window.EntroBulk.addItems([{ id: card.getAttribute('data-id'), quantity: qty }]).then(function (res) {
      if (res.added.length) {
        add.textContent = 'Added \u2713';
        add.classList.add('is-added');
        input.value = 1;
        setTimeout(function () { add.textContent = label; add.classList.remove('is-added'); }, 1800);
      } else {
        add.textContent = label;
        msg.innerHTML = '<span class="eb-err">' + ((res.skipped[0] && res.skipped[0].reason) || 'Could not be added') + '</span>';
      }
    }, function (err) {
      add.textContent = label;
      if (!err || !err.capped) msg.innerHTML = '<span class="eb-err">Something went wrong. Please try again.</span>';
    }).then(function () { add.disabled = false; });
  });

  document.addEventListener('change', function (e) {
    var card = e.target.closest('[data-entro-card]');
    if (card && e.target.matches('input')) clamp(card, e.target, e.target.value);
  });

  /* Enter in the qty box would submit the theme's hidden product form with quantity 1 */
  document.addEventListener('keydown', function (e) {
    var card = e.target.closest && e.target.closest('[data-entro-card]');
    if (card && e.key === 'Enter') { e.preventDefault(); card.querySelector('.eb-card__add').click(); }
  });
})();
